import React from 'react';
export default function SkeletonBarChart() {
    return /*#__PURE__*/ React.createElement("div", {
        className: "relative bg-white p-6 rounded-lg shadow-sm"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex items-start justify-between mb-6"
    }, /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("div", {
        className: "h-4 w-32 bg-gray-200 rounded animate-pulse mb-2"
    }), /*#__PURE__*/ React.createElement("div", {
        className: "h-7 w-24 bg-blue-200 rounded animate-pulse"
    })), /*#__PURE__*/ React.createElement("div", {
        className: "h-8 w-20 bg-gray-200 rounded animate-pulse"
    })), /*#__PURE__*/ React.createElement("div", {
        className: "relative h-[260px] pl-32 pr-6"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "absolute inset-0 flex justify-between"
    }, Array.from({
        length: 11
    }).map((_, i) => /*#__PURE__*/ React.createElement("div", {
        key: i,
        className: "w-px bg-gray-200"
    }))), /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-col justify-between h-full"
    }, ['アカウント登録', 'メール確認', 'プロフィール入力', 'サブスク', 'いいね'].map((_, i) => /*#__PURE__*/ React.createElement("div", {
        key: i,
        className: "flex items-center gap-4"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "absolute left-0 w-28 text-right"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "h-4 w-20 bg-gray-200 rounded animate-pulse ml-auto"
    })), /*#__PURE__*/ React.createElement("div", {
        className: "flex-1"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "h-6 bg-blue-200 rounded animate-pulse",
        style: {
            width: `${60 - i * 8}%`
        }
    }))))), /*#__PURE__*/ React.createElement("div", {
        className: "absolute -bottom-8 left-0 right-0 flex justify-between text-xs text-gray-400"
    }, ['0%', '10%', '20%', '30%', '40%', '50%', '60%', '70%', '80%', '90%', '100%'].map(v => /*#__PURE__*/ React.createElement("span", {
        key: v
    }, v)))));
}
